// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"987538ca3c24ae5cf2ec","147":"1ae3125a4da0f39f7c0e","251":"6a78d162706c6fa536a7","352":"20d4ce3845a13b60cc33","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};